import Vue from 'vue'
import Vuex from 'vuex'

import version from './modules/version'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    version
  },
  strict: debug
})
